import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import Styles from "../styles.module.scss";
import AuthHead from "../AuthHead";
import AuthMedia from '../authMedia';
import NotificationAlert from '../../../components/notification';
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { SignupForm } from './signupForm';
import { ISignUpResult } from "amazon-cognito-identity-js";
import {  postAPI } from '../../../api/api';
import * as Utils from '../../../utils/EllowUtils'
import  mixpanelData, { viewedpageMixpanel } from '../../../utils/mixpanel';
import { REACT_APP_RECRUITER } from '../../../utils/common';

Auth.configure({
  userPoolId: "ap-south-1_lqm8BWFqK",
  userPoolWebClientId: "2e2a5mhpfvqlj8oqsifqtdanhk", // app client id
  //identityPoolId: "42efbd0d-8bcb-46a2-b028-0a8affe3bb63",
  region: "ap-south-1",
  oauth: {
    region: "ap-south-1",
    domain: "ellow-prod-recruiter.auth.ap-south-1.amazoncognito.com",
    scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "https://talentgenie.ellow.io/login?provider=google",
    redirectSignOut: "https://talentgenie.ellow.io/login",
    responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  }
}); 

function Signup() {

  let navigate = useNavigate();

  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const[error,setError] = useState <string> ('')
  const [disableBtn, setDisableBtn] = useState<boolean>(false)
  const [flag, setFlag] = useState<boolean>(false)
  
  useEffect(() => {
     
    viewedpageMixpanel()
  }, [])  
  
  const submitValues = (data:any) => {
    
    let userData:any = {
      username: data.email.toLowerCase(),
      password: data.password
    }

    Auth.signUp({
      username: userData.username,
      password: userData.password,
      attributes: {
        email: userData.username.toLowerCase(),
        given_name: Utils.nameConversion(data.firstName),
        family_name: Utils.nameConversion(data.lastName),
        "custom:phonenumber": data.phone,
        "custom:roleid": data.role
      }
    }).then((result: ISignUpResult) => {
        
      let value = {
        role: data.role,
        loginId : result.userSub,
        userMetadata: {
          firstName: data.firstName,
          lastName: data.lastName,
          phone: data.phone,
          email: data.email.toLowerCase()
        }
      }
      postAPI( REACT_APP_RECRUITER + '/cs-recruiter', value).then((response: any) => {
        if(response && response.status === 1){
          navigate(`/dashboard`, {
            state: {
              loginId: value.loginId 
            }
          })
        }
      })
    })
    .catch(err => {    
      setError("An account with the given email already exists")
      mixpanelData('TG-Login Failed', userData)
    })
  } 

  
  const checkExcistingEmail = (email: string) => {
      
  }

  const removeMessage = (email: string) => {
    setError('')
    checkExcistingEmail(email)
  }

  return ( 
    <section className="App">
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <div className={Styles.alignCenter}>
            <aside className={Styles.loginSignupWapper}>
              <div className={Styles.loginWith}>
                <div>
                  <SignupForm ClickHandler={submitValues} disable={disableBtn} removeMessage={removeMessage}/>
                </div>
                  { error ?
                    <div><p className="error-message">{error}</p></div>
                   :
                   <div></div>
                   }
              
                {/* <div className={Styles.alreadyRegistered}>Already have an ellow account? <Link to="/login">Log in</Link></div> */}
              </div>
            </aside>
          </div>
        </div>
        <AuthMedia />
        {notification && <NotificationAlert onClose={() => setNotification((prev) =>!prev) } closable={true} >
          {message}
          </NotificationAlert> }
        </div>
    </section>
  );
}


export default Signup;
